import React, { useState } from 'react';
import PeopleRoles from './flow/PeopleRoles';
import StagesOwners from './flow/StagesOwners';
import StatusNames from './flow/StatusNames';

type Section = 'people' | 'stages' | 'names';

const SECTIONS: { id: Section; label: string }[] = [
  { id: 'people', label: 'People and roles' },
  { id: 'stages', label: 'Stages and owners' },
  { id: 'names', label: 'Status names' },
];

// Settings for the Flow page: who has which function, who owns each status, and how variant status
// names fold together. Everything starts from the Workflow Transition Ownership standard.
export default function FlowSettingsTab() {
  const [section, setSection] = useState<Section>('people');
  return (
    <div className="space-y-5">
      <div role="tablist" aria-label="Flow settings" className="inline-flex rounded-xl bg-gray-100 p-1">
        {SECTIONS.map((s) => {
          const on = section === s.id;
          return (
            <button
              key={s.id}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => setSection(s.id)}
              className={`rounded-lg px-3.5 py-1.5 text-sm font-medium transition-[background-color,color,box-shadow] duration-150 active:scale-[0.98] motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
                on ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {s.label}
            </button>
          );
        })}
      </div>
      {section === 'people' && <PeopleRoles />}
      {section === 'stages' && <StagesOwners />}
      {section === 'names' && <StatusNames />}
    </div>
  );
}
